import { useNavigate } from 'react-router-dom';
import { Grid, GridItem, Stack, Text } from '@chakra-ui/react';
import { useAccess, useProfile } from 'hooks';
import { useTranslation } from 'localization';
import { routes } from 'statics';

import { Button } from 'components';

const QuickAccess = () => {
  const { t } = useTranslation('component.dashboard.quickAccess');
  const navigate = useNavigate();
  const { data: profile } = useProfile();
  const access = useAccess();

  return (
    <Stack
      direction={{ base: 'column', xl: 'row' }}
      w="full"
      borderTopWidth="1px"
      borderTopColor="rgba(255,255,255,0.08)"
      justify="space-between"
      py={{ base: 6, xl: 6 }}
      px={{ base: 0, xl: 0 }}
      gap={0}
    >
      <Text
        fontSize="var(--chakra-font-sizes-2xl)"
        fontWeight="500"
        color="body"
        mb={{ base: 4, lg: 0 }}
      >
        {t('title')}
      </Text>
      <Grid
        templateColumns={{
          base: 'repeat(2, 1fr)',
          sm: 'repeat(2, 1fr)',
          xl: 'repeat(4, 1fr)',
        }}
        templateRows={{
          base: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
          lg: 'unset',
        }}
        pt={{ base: 0, lg: 10, xl: 0 }}
        textAlign={'center'}
        rowGap={{ base: '4', lg: '14' }}
        columnGap={{ base: '14', lg: '14' }}
      >
        <GridItem>
          <Button
            title={t('deposit')}
            variant="ghost"
            bg="rgba(255,255,255,0.05)"
            borderWidth={0}
            borderRadius="lg"
            minW={100}
            maxW={100}
            fontWeight="medium"
            fontSize="sm"
            color="primary"
            _hover={{ bg: 'rgba(255,255,255,0.1)', color: 'primary' }}
            onClick={() => navigate(routes.deposit.url)}
          />
        </GridItem>
        {access.withdrawService && (
          <GridItem>
            <Button
              title={t('withdraw')}
              variant="ghost"
              bg="rgba(255,255,255,0.05)"
              borderWidth={0}
              borderRadius="lg"
              minW={100}
              maxW={100}
              fontWeight="medium"
              fontSize="sm"
              color="error"
              _hover={{ bg: 'rgba(255,255,255,0.1)', color: 'error' }}
              onClick={() => navigate(routes.withdraw.url)}
            />
          </GridItem>
        )}
        <GridItem>
          <Button
            title={t('exchange')}
            variant="ghost"
            bg="rgba(255,255,255,0.05)"
            borderWidth={0}
            borderRadius="lg"
            minW={100}
            maxW={100}
            fontWeight="medium"
            fontSize="sm"
            color="body"
            _hover={{ bg: 'rgba(255,255,255,0.1)', color: 'body' }}
            onClick={() => navigate(routes.exchange.url)}
          />
        </GridItem>
        {access.transferService &&
          !['LD', 'BROKER'].includes(profile?.role.title || '') && (
            <GridItem>
              <Button
                title={t('transfer')}
                variant="ghost"
                bg="rgba(255,255,255,0.05)"
                borderWidth={0}
                borderRadius="lg"
                minW={100}
                maxW={100}
                fontWeight="medium"
                fontSize="sm"
                color="body"
                _hover={{ bg: 'rgba(255,255,255,0.1)', color: 'body' }}
                onClick={() => navigate(routes.transfer.url)}
              />
            </GridItem>
          )}
      </Grid>
    </Stack>
  );
};
export default QuickAccess;
